import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {
  getPageQuery,
  setUser,
  setToken,
  getUser as getCurrent,
  setPlatConfig,
  getPlatConfig,
  setParamBiz,
  getSiteIp,
  getTenantInfo,
  setTenantInfo,
} from './utils';
import { getUser } from './services/tscloud/user';
import { getUserInfo } from './services/saas/user';
import { info as tenantInfo } from './services/saas/tenant';
import { query as bizParam } from './services/saas/parambiz';
import { Toast } from 'antd-mobile';
import defaultAvator from './images/ico_user_avator.png';

async function initSaas() {
  const respTenant: any = await tenantInfo({ domain: window.location.hostname });
  if (respTenant && respTenant.success) {
    setTenantInfo(respTenant.data);
  }
  const paramArr = [
    'chat_tool',
    'watch_record_heartbeat_interval',
    'third_login_address_h5',
    'live_play_agreement_monitoring',
    'res_play_comment_on_switch',
  ];
  const appBizParam = await bizParam({
    paramKeys: paramArr.join(','),
  });
  if (appBizParam && appBizParam.success) {
    setParamBiz(appBizParam.data);
  }
  if (!getCurrent()) {
    try {
      const { token } = getPageQuery();
      if (token) {
        setToken(token);
        const respUser: any = await getUserInfo();
        if (respUser && respUser.success) {
          const {
            account,
            deptName,
            tenantId,
            realName,
            id,
            avatar,
            userType,
            deptId,
            name,
          } = respUser.data;
          setUser({
            userId: id,
            userName: realName,
            photo: avatar || defaultAvator,
            schoolName: deptName,
            platMark: tenantId,
            loginName: account,
            userType,
            deptId,
            nickName: name,
          });
        }
      }
    } catch (err) {
      Toast.info(err);
    }
  }
}

async function initTscloud() {
  const { userId, platformUrl } = getPageQuery();
  if (!getCurrent() && userId) {
    try {
      const respUser: any = await getUser(userId);
      if (respUser && respUser.uuid) {
        const { uuid, photo, trueName, school, platMarkUuid, loginName } = respUser;
        setUser({
          userId: uuid,
          userName: trueName,
          photo: photo ? `${platformUrl || ''}/download/i${photo}` : defaultAvator,
          schoolName: school && school.schoolName ? school.schoolName : '',
          platMark: platMarkUuid,
          loginName,
          nickName: loginName,
        });
      } else {
        Toast.info(respUser.retDesc);
      }
    } catch (err) {
      Toast.info(err);
    }
  }
}

async function init() {
  const { platformType = 'saas', platformUrl } = getPageQuery();
  if (!getPlatConfig()) {
    setPlatConfig({
      reqIp: getSiteIp(),
      platformUrl,
      platformType,
    });
  }
  return platformType === 'saas' ? initSaas() : initTscloud();
}

init().then(() => {
  const { platformName } = getTenantInfo() || { platformName: 'Tscloud App' };
  document.title = platformName;
  ReactDOM.render(<App />, document.getElementById('root'));
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
